export const header = {
  inlineContent: { content: null },
  bottomContent: { content: null },
  options: {}
}
